import Axios from "axios";
import { WebSiteConfig, TokenLocalStorageKey, NotAuthPages } from "base/Constant";
import toast from "react-hot-toast";
import ToastMsg from "components/Toast";

const axiosInstance = Axios.create({
    baseURL: WebSiteConfig.BaseRequestUrl,
    timeout: 100000,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=utf-8'
    },
    params: {},
    data: {}
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    Promise.reject(error);
});

axiosInstance.interceptors.response.use((response) => {
    const { message, code, data } = response?.data || {};
    const isInvalidAuthenticationTokenError = data?.error?.code === 'InvalidAuthenticationToken';
    if (isInvalidAuthenticationTokenError && !NotAuthPages.includes(window.location.pathname)) {
        window.localStorage.setItem(TokenLocalStorageKey, '');
        ToastMsg("Authentication has expired，please login again", "error");
        window.location.href = `${window.location.origin}`;
    }
    return response;
}, error => {
    return Promise.reject(error)
})

export const postReq = async (path, data, token) => {
    return await Axios.post(path, data, token ? {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    } : {});
}

/**
 * 通用Post接口请求
 */
export async function commonAxiosPostRequest(path, params, options) {
    let tid;
    if (options?.showLoading) {
        tid = toast.loading('Loading...');
    }
    try {
        const token = localStorage.getItem(TokenLocalStorageKey);
        const result = await axiosInstance.post(path, params || {}, {
            headers: { Authorization: token ? `Bearer ${token || ''}` : '' },
            ...(options?.timeout ? { timeout: options.timeout } : {}),
        });
        const { code, data, message } = result?.data || {};
        if (code === 200) {
            return [null, data];
        }
        const msg = result?.data?.data?.error?.message || '';
        const errorMessage = msg || message || 'System error';
        return [{ message: errorMessage, code }, null];
    } catch (error) {
        const { code, message } = error || {};
        return [{ message: message || 'request error', code }, null];
    } finally {
        tid && toast.dismiss(tid);
    }
}

/**
 * 通用Get接口请求
 */
export async function commonAxiosGetRequest(path, params, options) {
    let tid;
    if (options?.showLoading) {
        tid = toast.loading('Loading...');
    }
    try {
        const token = localStorage.getItem(TokenLocalStorageKey);
        const result = await axiosInstance.get(path, {
            headers: { Authorization: token ? `Bearer ${token || ''}` : '' },
            params,
            ...(options?.timeout ? { timeout: options.timeout } : {}),
        });
        const { code, data, message } = result?.data || {};
        if (code === 200) {
            return [null, data];
        }
        const errorMessage = (typeof data === 'string' && data ? data : message);
        return [{ message: errorMessage, code }, null];
    } catch (error) {
        const { code, message } = error || {};
        return [{ message: message || 'request error', code }, null];
    } finally {
        tid && toast.dismiss(tid);
    }
}

export async function commonAxiosMock(data, delay, listLen) {
    return new Promise((resolve) => {
        setTimeout(() => {
            const result = listLen ? new Array(listLen).fill({}).map(() => data) : data;
            resolve([null, result]);
        }, delay || 1000);
    });
}

export default axiosInstance;